import { ConflictType } from '@editor2/types/conflict';
import { PageGroupChildrenReorderConflictResolver } from './childrenReorderResolver';
import { PageGroupDeletedModifiedConflictResolver } from './deletedModifiedResolver';
import { PageGroupItemMoveConflictResolver } from './itemMoveResolver';
import { PageGroupModifiedDeletedConflictResolver } from './modifiedDeletedResolver';
import { PageGroupPropertyConflictResolver } from './propertyResolver';

export class PageGroupResolver {
	getTypeResolver = (key: ConflictType) => {
		switch (key) {
			case ConflictType.Property: {
				const resolver = new PageGroupPropertyConflictResolver();
				return resolver;
			}

			case ConflictType.DeletedModified: {
				const resolver = new PageGroupDeletedModifiedConflictResolver();
				return resolver;
			}

			case ConflictType.ModifiedDeleted: {
				const resolver = new PageGroupModifiedDeletedConflictResolver();
				return resolver;
			}

			case ConflictType.ChildrenReorder: {
				const resolver = new PageGroupChildrenReorderConflictResolver();
				return resolver;
			}

			case ConflictType.ItemMove: {
				const resolver = new PageGroupItemMoveConflictResolver();
				return resolver;
			}

			default:
				break;
		}
	};
}
